/**
 * for post subscription/orderCheckout option request
 * @export
 * @class SubscriptionOrderParam
 */

export default class SubscriptionOrderCheckoutParam {
  public cardNumber: string = ''
  public expirationDate: string = ''
  public securityCode: string = ''

  public constructor(fields?: {
    cardNumber?: string,
    expirationDate?: string,
    securityCode?: string,
  }) {
    if (fields) {
      Object.assign(this, fields)
    }
  }
}
